<template>
  <div class="study-path-view">
    <div class="study-view">
      <!-- <title-bar class="title-bar-view" :title="'学习地图'" :showAll="false"></title-bar> -->
      <LearnRate v-if="learnRateData.length > 0" :init-data="learnRateData" />
    </div>
  </div>
</template>

<script>
import TitleBar from '../../../components/TitleBar.vue'
import LearnRate from './LearnRateComponent.vue'
export default {
  name: 'StudyMap',
  components: {
    TitleBar,
    LearnRate
  },
  props: {
    initData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      learnRateData: []
    }
  },
  watch: {
    initData: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.init()
        }
      },
      deep: true // 深度监听
      //   immediate: true
    }
  },
  methods: {
    init() {
      this.learnRateData = JSON.parse(JSON.stringify(this.initData.stages))
      console.log('🚀 ~ file: studyMap.vue:46 ~ init ~ this.learnRateData:', this.learnRateData)
    }
  }
}
</script>

<style lang="less" scoped>
.title-bar-view {
  margin-top: 15px;
  padding: 0 13px;
}
</style>



// WEBPACK FOOTER //
// src/views/home/components/StudyMap.vue